module.exports = __webpack_public_path__ + "img/pay-folders.4ccdfdad.svg";